import { OptimizelyLongString, OptimizelyXhtmlString, OptimizelyUrl } from "..";
import { OptimizelyBlockExpandedValue } from "../expanded";

export interface OptimizelyContactsBlock extends OptimizelyBlockExpandedValue {
    icon1: OptimizelyLongString;
    icon2: OptimizelyLongString;
    icon3: OptimizelyLongString;
    icon4: OptimizelyLongString;
    title1: OptimizelyLongString;
    title2: OptimizelyLongString;
    title3: OptimizelyLongString;
    title4: OptimizelyLongString;
    textEditor1: OptimizelyXhtmlString;
    textEditor2: OptimizelyXhtmlString;
    textEditor3: OptimizelyXhtmlString;
    textEditor4: OptimizelyXhtmlString;
    linkLabel1: OptimizelyLongString;
    linkLabel2: OptimizelyLongString;
    linkLabel3: OptimizelyLongString;
    linkLabel4: OptimizelyLongString;
    link1: OptimizelyUrl;
    link2: OptimizelyUrl;
    link3: OptimizelyUrl;
    link4: OptimizelyUrl;
}

export const isContactsBlock = (
    block: OptimizelyBlockExpandedValue
): block is OptimizelyContactsBlock => {
    return block.contentType[1] === "ContactsBlock";
};